import { useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { VIDEO_INTEGRATION_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { routeReplacer } from '~/Helpers/String.helper';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IVODCreateResponse } from '~/Models/DTO/VideoOnDemand.models';

export const useRequestGetVideoById = (videoId = 'unknown' as string) => {
  const { isLoading, error, data, refetch } = useQuery<IVODCreateResponse, IErrorResponse>(
    REQUEST_ACTIONS.GET_VOD_VIDEO_BY_ID,
    () =>
      requestReactQuery<IVODCreateResponse>({
        url: routeReplacer(VIDEO_INTEGRATION_SERVICE_URLS.VOD_GET_VIDEO, {
          videoId,
        }),
        config: { method: 'GET' },
      }),
    {
      enabled: false,
      cacheTime: 0,
    },
  );

  return {
    getVideoLoading: isLoading,
    vodError: error as IErrorResponse,
    videoData: data,
    getVideoById: refetch,
  };
};
